import http from './http';

export const queryFetch = async ({ queryKey }: any) => {
  const [_key, _params] = queryKey;
  const { data } = await http.get(_key, {
    params: _params
  });
  return data;
};
